import TalksPresenterControls from './TalksPresenterControls'
import { TalksPresenterControlsProps } from './types'
import { connect } from 'react-redux'
import { State } from '../../dataStore/reducers/reducerType'
import { showSettingsModal } from '../../dataStore/actions/ui/uiActions'
import { toggleAudio, toggleVideo } from '../../dataStore/actions/tracks/trackActions'
import selectPresenterMuted from '../../dataStore/selectors/selectPresenterMuted'
import selectPresenterHidden from '../../dataStore/selectors/selectPresenterHidden'
import selectVideoButtonDisabled from '../../dataStore/selectors/selectVideoButtonDisabled'
import username from '../../lib/username'
import selectPresenterDialedIn from '../../dataStore/selectors/selectPresenterDialedIn'
import selectIsLocalParticipantDialedIn from '../../dataStore/selectors/selectIsLocalParticipantDialedIn'
import selectIsParticipantNotSpotlighted from '../../dataStore/selectors/selectIsPresenterNotSpotlighted'
import { updatePermissions } from '../../dataStore/actions/room/room'
import { mediaType as MediaType} from '@bt-react/constants'
import { PlayInStatus } from '../../lib/playIn/types'

type DispatchTypes = 'onClickAudio' | 'onClickVideo' | 'onClickSettings' | 'checkDevicePermissions'

const makeMapStateToProps = () => {

  const getPresenterHidden = selectPresenterHidden()
  const getPresenterMuted = selectPresenterMuted()
  const getPresenterDialedIn = selectPresenterDialedIn()

  const getVideoButtonDisabled = selectVideoButtonDisabled()

  const mapStateToProps = (state: State, props: Pick<TalksPresenterControlsProps, 'participant' | 'dataBdd'>): Omit<TalksPresenterControlsProps, DispatchTypes> => {

    const isLocal = props.participant.id === username.getPureUsername(state.config.username || '')

    const getAudioSource = () => {

      if (isLocal) return state.tracks.audioSource
      if (getPresenterDialedIn(state, {presenter: { BTID: props.participant.id }})) return 'telephone'
      return 'microphone'

    }

    return {
      isLocal,
      audioSource: getAudioSource(),
      participant: props.participant,
      isHidden: getPresenterHidden(state, { presenter: { BTID: props.participant.id }}),
      isMuted: getPresenterMuted(state, { presenter: { BTID: props.participant.id }}),
      isDialInConnected: isLocal ? selectIsLocalParticipantDialedIn(state) : getPresenterDialedIn(state, {presenter: { BTID: props.participant.id }}),
      isVideoButtonDisabled: state.syncUi.mediaType === MediaType.SPOTLIGHT && !state.layouts.presenterLayout.sidebarActive ?
        selectIsParticipantNotSpotlighted(state, { presenter: { BTID: props.participant.id } }) : getVideoButtonDisabled(state, { isLocal }),
      isAudioButtonDisabled: state.room.mediaType === MediaType.PLAY_IN && state.playIn.status === PlayInStatus.PLAYING
      || state.room.mediaType === MediaType.EVENT_STREAM,
      hasAudioError: isLocal &&
        !state.config.devicePermissions.find((perm) => perm.kind === 'audioinput'),
      hasVideoError: isLocal &&
        !state.config.devicePermissions.find((perm) => perm.kind === 'videoinput'),
      dataBdd: props.dataBdd
    }

  }

  return mapStateToProps

}

const mapDispatchToProps = (dispatch): Pick<TalksPresenterControlsProps, DispatchTypes> => ({
  onClickAudio: (BTID) => dispatch(toggleAudio(BTID || '')),
  onClickVideo: (BTID) => dispatch(toggleVideo(BTID || '')),
  onClickSettings: () => dispatch(showSettingsModal()),
  checkDevicePermissions: () => dispatch(updatePermissions())
})

export default connect(makeMapStateToProps, mapDispatchToProps)(TalksPresenterControls)
